import { render, staticRenderFns } from "./HouseTypeConfigInfo.vue?vue&type=template&id=9c9e5392&scoped=true&"
import script from "./HouseTypeConfigInfo.vue?vue&type=script&lang=js&"
export * from "./HouseTypeConfigInfo.vue?vue&type=script&lang=js&"
import style0 from "./HouseTypeConfigInfo.vue?vue&type=style&index=0&id=9c9e5392&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9e5392",
  null
  
)

export default component.exports